<template>
  <div class="header">
    <div class="header-slot">
      <slot></slot>
    </div>
    <div @click="revertUpper">
      <slot name="revert"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonalCenterHead',
  methods: {
    revertUpper () {
      this.$router.push('/home')
    }
  }

}

</script>
<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #e8e8e8;
  .header-slot {
    font-size: 28px;
    color: #212529;
    font-weight: 600;
  }
  .revert {
    width: 50px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    color: #ffffff;
    background-color: #6c757d;
    border-radius: 4px;
    cursor: pointer;
    transition: 0.5s all;
    // &:hover {
    //   background-color: #6c759d;
    // }
  }
}
</style>